let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("2nh75")).then(() => parcelRequire('kOV42'));